import React, { type FormEvent, useRef } from 'react';

import { useLogin } from 'src/hooks/useLogin';

import type { HNSkjemaFrontend } from 'src/types/Resources';

import { AnchorHelpTrigger } from './AnchorHelpTrigger';

type Props = {
  word: string;
  openSidebar: (e: Event | FormEvent<unknown> | undefined) => void;
  resources: HNSkjemaFrontend;
};
export const ReplaceLink = ({ word, openSidebar, resources }: Props): React.JSX.Element | null => {
  const { login } = useLogin();
  const anchorRef = useRef<HTMLButtonElement>(null);

  if (word.indexOf('{omSkjemaLink}') > -1) {
    return <AnchorHelpTrigger openSidebar={openSidebar} />;
  } else if (word.indexOf('{loginLink}') > -1) {
    return (
      <React.Fragment>
        <button className="button-link" role="link" ref={anchorRef} onClick={() => login(anchorRef)}>
          {word.replace('{loginLink}', resources.loggeInnLinkText)}
        </button>
        {` `}
      </React.Fragment>
    );
  } else if (word.indexOf('{personverninnstillingerLink}') > -1) {
    return (
      <React.Fragment>
        <a href="/personverninnstillinger">{word.replace('{personverninnstillingerLink}', resources.personverninnstillingerLink)}</a>
        {` `}
      </React.Fragment>
    );
  }
  return <React.Fragment>{`${word} `}</React.Fragment>;
};
